export const ORTHO_ASSETS = {
  'knee-bend-0.png': '/ortho/knee-bend-angles-0.png',
  'knee-bend-5.png': '/ortho/knee-bend-angles-5.png',
  'knee-bend-10.png': '/ortho/knee-bend-angles-10.png',
  'knee-bend-15.png': '/ortho/knee-bend-angles-15.png',
  'knee-bend-20.png': '/ortho/knee-bend-angles-20.png',
  'knee-bend-25.png': '/ortho/knee-bend-angles-25.png',
  'knee-bend-30.png': '/ortho/knee-bend-angles-30.png',
  'knee-bend-35.png': '/ortho/knee-bend-angles-35.png',
  'knee-bend-40.png': '/ortho/knee-bend-angles-40.png',
  'knee-bend-45.png': '/ortho/knee-bend-angles-45.png',
  'knee-bend-50.png': '/ortho/knee-bend-angles-50.png',
  'knee-bend-55.png': '/ortho/knee-bend-angles-55.png',
  'knee-bend-60.png': '/ortho/knee-bend-angles-60.png',
  'knee-bend-65.png': '/ortho/knee-bend-angles-65.png',
  'knee-bend-70.png': '/ortho/knee-bend-angles-70.png',
  'knee-bend-75.png': '/ortho/knee-bend-angles-75.png',
  'knee-bend-80.png': '/ortho/knee-bend-angles-80.png',
  'knee-bend-85.png': '/ortho/knee-bend-angles-85.png',
  'knee-bend-90.png': '/ortho/knee-bend-angles-90.png',
  'knee-bend-95.png': '/ortho/knee-bend-angles-95.png',
  'knee-bend-100.png': '/ortho/knee-bend-angles-100.png',
  'knee-bend-105.png': '/ortho/knee-bend-angles-105.png',
  'knee-bend-110.png': '/ortho/knee-bend-angles-110.png',
  'knee-bend-115.png': '/ortho/knee-bend-angles-115.png',
  'knee-bend-120.png': '/ortho/knee-bend-angles-120.png',
  'knee-bend-angles-0.png': '/ortho/knee-bend-angles-0.png',
  'knee-bend-angles-5.png': '/ortho/knee-bend-angles-5.png',
  'knee-bend-angles-10.png': '/ortho/knee-bend-angles-10.png',
  'knee-bend-angles-15.png': '/ortho/knee-bend-angles-15.png',
  'knee-bend-angles-20.png': '/ortho/knee-bend-angles-20.png',
  'knee-bend-angles-25.png': '/ortho/knee-bend-angles-25.png',
  'knee-bend-angles-30.png': '/ortho/knee-bend-angles-30.png',
  'knee-bend-angles-35.png': '/ortho/knee-bend-angles-35.png',
  'knee-bend-angles-40.png': '/ortho/knee-bend-angles-40.png',
  'knee-bend-angles-45.png': '/ortho/knee-bend-angles-45.png',
  'knee-bend-angles-50.png': '/ortho/knee-bend-angles-50.png',
  'knee-bend-angles-55.png': '/ortho/knee-bend-angles-55.png',
  'knee-bend-angles-60.png': '/ortho/knee-bend-angles-60.png',
  'knee-bend-angles-65.png': '/ortho/knee-bend-angles-65.png',
  'knee-bend-angles-70.png': '/ortho/knee-bend-angles-70.png',
  'knee-bend-angles-75.png': '/ortho/knee-bend-angles-75.png',
  'knee-bend-angles-80.png': '/ortho/knee-bend-angles-80.png',
  'knee-bend-angles-85.png': '/ortho/knee-bend-angles-85.png',
  'knee-bend-angles-90.png': '/ortho/knee-bend-angles-90.png',
  'knee-bend-angles-95.png': '/ortho/knee-bend-angles-95.png',
  'knee-bend-angles-100.png': '/ortho/knee-bend-angles-100.png',
  'knee-bend-angles-105.png': '/ortho/knee-bend-angles-105.png',
  'knee-bend-angles-110.png': '/ortho/knee-bend-angles-110.png',
  'knee-bend-angles-115.png': '/ortho/knee-bend-angles-115.png',
  'knee-bend-angles-120.png': '/ortho/knee-bend-angles-120.png',
  'knee-straightening-0.png': '/ortho/knee-straightening-0.png',
  'knee-straightening-05.png': '/ortho/knee-straightening-5.png',
  'knee-straightening-5.png': '/ortho/knee-straightening-5.png',
  'knee-straightening-10.png': '/ortho/knee-straightening-10.png',
  'knee-straightening-15.png': '/ortho/knee-straightening-15.png',
  'knee-straightening-20.png': '/ortho/knee-straightening-20.png',
  'knee-straightening-25.png': '/ortho/knee-straightening-25.png',
  'knee-straightening-30.png': '/ortho/knee-straightening-30.png',
};
